module.exports = __webpack_public_path__ + "static/img/HK@3x.acdcc85c.png";